import { useState, type ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { SystemInfoModal } from './SystemInfoModal'
import { ToastProvider } from '../common/Toast'

interface LayoutProps {
  children?: ReactNode
  showSysInfo?: boolean // Backward compatibility - controls initial system info visibility
}

export type { LayoutProps }

export function Layout({ children, showSysInfo = false }: LayoutProps) {
  const [showSystemInfo, setShowSystemInfo] = useState(showSysInfo)

  return (
    <ToastProvider>
      <div className="min-h-screen flex flex-col bg-surface">
        <Header />

        <main className="flex-1 w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {children || <Outlet />}
        </main>

        <Footer />

        <SystemInfoModal
          isOpen={showSystemInfo}
          onClose={() => setShowSystemInfo(false)}
        />
      </div>
    </ToastProvider>
  )
}

export default Layout
